/**
 * @generated SignedSource<<3807f68b1433ae49ee2255183d74789b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditDates_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDatesList_data">;
  readonly " $fragmentType": "PackageEditDates_data";
};
export type PackageEditDates_data$key = {
  readonly " $data"?: PackageEditDates_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDates_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditDates_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditDatesList_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ea4a821c23ca1f684c75dc1adc245bb9";

export default node;
